import { render, staticRenderFns } from "./indexPart2.vue?vue&type=template&id=58bfb120&scoped=true&"
import script from "./indexPart2.vue?vue&type=script&lang=js&"
export * from "./indexPart2.vue?vue&type=script&lang=js&"
import style0 from "./indexPart2.vue?vue&type=style&index=0&id=58bfb120&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bfb120",
  null
  
)

export default component.exports